/*
*###############################################################################
*Module Name                   : VoucherTransferInController.js                #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Thursday, January 6th 2022, 9:53:19 am        #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
const getLocationDets = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Locations/select`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getVoucherGroup = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherGroup/`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}



const getVoucherBook = async (Category, Location) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  console.log(Category)
  await fetch(`${ApiURL}VoucherTRO/GetBookList/${Category}/${Location}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getVoucherNumber = async (Category, Location) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  console.log(Category)
  await fetch(`${ApiURL}VoucherTRO/GetVoucherNumberList/${Category}/${Location}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}
// Voucher Group save method
const setVoucherSave = async (
  strVoucherCode,
  strVoucherDate,
  LocationCode,
  LogCompanyCode,
  strFromLocation,
  strToLocation,
  strRemarks1,
  strRemarks2,
  strRefNo,
  LogUserType,
  menuCode,
  LogCompanyCodenew,
  LocationCodenew,
  strReason,
  VoucherPoDet

) => {
  var myHeaders = new Headers()
  const authToken = localStorage.getItem("authToken")
  myHeaders.append("Authorization", `Bearer ${authToken}`)
  myHeaders.append("Content-Type", "application/json")

  var raw = JSON.stringify({
    strType: 'VTI',
    strRunNo: strVoucherCode == "" ? "NAN" : strVoucherCode,
    dtTxnDate: strVoucherDate,
    dtTxnTime: strVoucherDate,
    strSetupLoc: LocationCode,
    strComCode: LogCompanyCode,
    strFromLocCode: strFromLocation,
    strToLocCode: strToLocation,
    strRef1: strRemarks1,
    strRef2: strRemarks2,
    strRefNo: strRefNo,
    strBatchNo: '',
    intHedProcess: 1,
    intHedCancelled: 0,
    dtCancellDate: '1900-01-01',
    strCancelldUser: '',
    dbPrintCount: 0,
    intHedFullyUsed: 1,
    intExport: 0,
    strExportBatch: '',
    strCreateBy: LogUserType,
    strMenuCode: menuCode,
    strLoggedCompany: LogCompanyCode,
    strLoggedLocation: LocationCode,
    strReason: LogCompanyCode,
    VCTRIDETAILS: VoucherPoDet

  })


  const ApiURL = window.Links.ApiURL
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  }

  var data = [];
  await fetch(`${ApiURL}VoucherTRI/Save`, requestOptions)
    .then(response => data = response)
    .catch(error => console.log('error', error))
  return data;
}


const getVoucherTOSearch = async LocationCode => {

  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherTRO/PendingTranferOut/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getVoucherTOHeader = async id => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherPO/search/${id}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

// const getVoucherPendingTOHeader = async (id, LocationCode) => {

//   const ApiURL = window.Links.ApiURL
//   const authToken = localStorage.getItem("authToken")

//   var requestOptions = {
//     method: "GET",
//     headers: {
//       "Authorization": `Bearer ${authToken}`
//     },
//     redirect: "follow",
//   }
//   await fetch(`${ApiURL}VoucherTRI/HeadOffice/Pendingsearch/${id}/${LocationCode}`, requestOptions)
//     .then(response => response.json())
//     .then(result => {


//       if (result.success) {
//         return { success: true, data: result.data }
//       }

//       return { success: false, data: [] }
//     })
//     .catch(error => {
//       console.log("error", error)
//       return { success: false, data: [] }
//     })

// }


const getVoucherPendingTOHeader = async (id, LocationCode) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${authToken}`,
      },
      redirect: "follow",
    };

    const response = await fetch(`${ApiURL}VoucherTRI/HeadOffice/Pendingsearch/${id}/${LocationCode}`, requestOptions);
    const result = await response.json();

    if (result.success) {
      return { success: true, data: result.data };
    }

    return { success: false, data: [] };
  } catch (error) {
    console.error("Error:", error);
    return { success: false, data: [] };
  }
};

const getVoucherTRISearch = async (LocationCode) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherTRI/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}
const getVoucherTRIHeader = async (id, LocationCode) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var success = false
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherTRI/HeadOffice/search/${id}/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
      success = result.success
    })
    .catch(error => console.log("error", error))
  return { data, success }
}


export {
  getLocationDets,
  getVoucherGroup,
  setVoucherSave,
  getVoucherTOSearch,
  getVoucherTOHeader,
  getVoucherTRISearch,
  getVoucherTRIHeader,
  getVoucherPendingTOHeader,
  getVoucherBook,
  getVoucherNumber
}